<template>
    <div class="header-container">
        <div class="header">
            <div class="flex align-center">
<!--                <router-link to="/home">-->
<!--                    <img :src="orginizInfo.morglogo" alt="" class="logo" v-if="orginizInfo.morglogo"/>-->
<!--                    <img src="../../../assets/img/logo_1.png" alt="" class="logo" v-else/>-->
<!--                </router-link>-->
                <a :href="`${IMAGE_PATH}`">
                    <img :src="orginizInfo.morglogo" alt="" class="logo" v-if="orginizInfo.morglogo"/>
                </a>
                <div class="title">{{ orginizInfo.morgname }} 会员管理</div>
            </div>
            <div class="home flex align-center">
                <div class="service"><i
                    class="iconfont icon-kefu margin-right-xs font-size-lg"></i>客服电话：{{ orginizInfo.kefu_tel }}
                </div>
                <el-badge :value="noticeCount" :hidden="noticeCount === 0" class="margin-lr-sm">
                    <i class="notice iconfont icon-xiaoxi" @click="openApplyLog"></i>
                </el-badge>
                <div class="header-operate flex flex-direction align-center justify-center" v-if="list>1" @click="toChiose">
                    <i class="icon iconfont icon-jiaohuan"></i>
                    <div class="label">角色选择</div>
                </div>
                <div class="header-operate flex flex-direction align-center justify-center">
                    <div class="flex align-center">
                        <i class="icon iconfont icon-saoyisao_o"></i>
                        <div class="label">扫一扫</div>
                    </div>
                    <div class="label">进入小程序</div>
                    <div class="wx-mini-container flex flex-direction justify-center align-center">
                        <img class="image" src="../../../assets/img/erweima_wx_mini.jpg"/>
                        <div class="tips">扫一扫 进入小程序</div>
                    </div>
                </div>

                <div class="header-operate flex flex-direction align-center justify-center" v-if="user" @click="sginout">
                    <i class="icon iconfont icon-logout"></i>
                    <div class="label">退出登录</div>
                </div>
<!--                <div class="operate" v-if="list>1" @click="toChiose">角色选择</div>-->
<!--                <div class="operate" v-if="user" @click="sginout">退出</div>-->
            </div>
        </div>
        <el-drawer
            title="我是标题"
            :visible.sync="drawer"
            :with-header="false">
            <div class="apply-result flex flex-direction">
                <div class="flex align-center justify-between">
                    <div class="title">审批流程</div>
                    <i class="close el-icon-close" @click="drawer = false"></i>
                </div>
                <div class="status-list flex flex-direction">
                    <div class="item-status" :class="{active:index !== lists.length - 1}" v-for="(item,index) in lists"
                         :key="index">
                        <div class="time">{{ item.create_time }}</div>
                        <div class="title">{{ item.msg }}<i class="el-icon-check"></i></div>
                    </div>
                </div>
            </div>
        </el-drawer>
    </div>
</template>

<script>
import {getApplyLog, getOrganizInfo, userRemindState} from '@/api/member'
import {zhDate} from '@/utils/utils'
import {IMAGE_PATH} from "@/config";

export default {
    components: {},
    name: "headers",
    data() {
        return {
            IMAGE_PATH:IMAGE_PATH,
            drawer: false,
            lists: [],
            orginizInfo: '',
            noticeCount: 0,
            list: 1,
        }
    },
    props: {},
    computed: {
        user() {
            return this.$store.state.user
        }
    },
    created() {
        this.list = this.$store.state.userAll.length
        this.getOrganizInfo()
    },
    methods: {
        async getOrganizInfo() {
            let _data = await getOrganizInfo()
            if (_data.status === 200) {
                this.orginizInfo = _data.data
            }
            _data = await userRemindState()
            if (_data.status === 200) {
                this.noticeCount = _data.data
            }
        },
        openApplyLog() {
            this.noticeCount = 0
            this.drawer = true
            this.init()
        },
        async init() {
            let _data = await getApplyLog()
            if (_data.status === 200) {
                _data.data.map(item => {
                    item.create_time = zhDate(item.create_time * 1000)
                })
                this.lists = _data.data
            }

        },
        toChiose() {
            this.$router.replace('/choice')
        },
        sginout() {
            this.$confirm(
                '您确定要退出吗？',
                '温馨提示', {
                    confirmButtonText: '确定',
                    type: 'warning',
                    closeOnClickModal: false,
                    closeOnPressEscape: false,
                }
            ).then(() => {
                this.$store.dispatch('LogOut').then(() => {
                    this.$router.replace('/login')
                    window.localStorage.clear()
                    // location.reload() // 为了重新实例化vue-router对象 避免bug
                })
            })
        }
    }
}
</script>

<style scoped lang="scss">
.header-container {
    background-color: #0a2240;
    box-shadow: 0px 6px 18px 1px rgba(10, 34, 64, 0.45);
    width: 100%;

    .header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 1200px;
        height: 100px;
        margin: 0 auto;

        .logo {
            margin: 20px 0;
            height: 59px;
            width: 59px;
            border-radius: 59px;
        }

        .title {
            font-size: 24px;
            font-weight: bold;
            color: #ffffff;
            margin-left: 20px;
        }

        .home {
            .service {
                font-size: 16px;
                color: #f5f5f5;
                margin-right: 20px;
            }

            .notice {
                font-size: 27px;
                color: #ff9600;
                cursor: pointer;
            }

            .operate {
                padding: 0 26px;
                height: 40px;
                background-color: #ff9600;
                border-radius: 20px;
                font-size: 16px;
                color: #ffffff;
                line-height: 40px;
                text-align: center;
                cursor: pointer;
                user-select: none;
                margin-left: 12px;
            }
        }
    }

    .apply-result {
        padding: 30px;

        .title {
            font-size: 22px;
            font-weight: bold;
            color: #0a2240;
        }

        .close {
            font-size: 30px;
            color: #0a2240;
            cursor: pointer;
        }

        .status-list {
            .item-status {
                padding-left: 20px;

                &.active {
                    position: relative;

                    &:before {
                        position: absolute;
                        content: '';
                        width: 2px;
                        height: 100%;
                        background-color: #0a2240;
                        left: 4px;
                        top: 45px;
                        bottom: 0;
                    }
                }

                .time {
                    font-size: 14px;
                    color: #7889a4;
                    position: relative;
                    margin-top: 40px;

                    &:before {
                        position: absolute;
                        content: '';
                        width: 10px;
                        height: 10px;
                        border-radius: 10px;
                        background-color: #0a2240;
                        left: -20px;
                        top: 50%;
                        transform: translateY(-50%);
                    }
                }

                .title {
                    min-height: 57px;
                    padding: 20px;
                    background-color: #f3f7fb;
                    border-radius: 10px;
                    font-size: 14px;
                    color: #0a2240;
                    margin-top: 12px;

                    i {
                        font-size: 18px;
                        color: #ff9600;
                        font-weight: bold;
                        margin-left: 12px;
                    }
                }
            }
        }
    }
}
</style>
